/**
 * @file    resolveLegacyAlias.ts
 * @scope   SHARED
 * @summary Maps a widget alias to the DynamicTable / DynamicTableOld variant chosen by
 *          `dataGridFeatureFlag` (backward compatibility).
 * @consumes Nothing.
 * @produces resolveLegacyAlias
 * @sideEffects None.
 */

/**
 * @param alias Widget alias (persisted or descriptor `renderBinding`).
 * @param dataGridFeatureFlag `configDashboard.dataGridFeatureFlag`.
 * @returns The alias to render with.
 */
export const resolveLegacyAlias = (alias: string, dataGridFeatureFlag?: boolean): string => {
  if (dataGridFeatureFlag && alias === 'DynamicTableOld') return 'DynamicTable';
  if (!dataGridFeatureFlag && alias === 'DynamicTable') return 'DynamicTableOld';
  return alias;
};
